





































import { DialogMixin, ModelEditableMixin } from "../../../components/system";
import { Component, Mixins } from "vue-property-decorator";

export interface IListMultiSortConditionPresetNameDialogParameter {
  isAdd: boolean;
  presetName: string;
  isEditDefault: boolean;
}

export interface IListMultiSortConditionPresetNameDialogResult {
  result: boolean;
  presetName: string;
  defaultSort: boolean;
}

@Component
export default class ListMultiSortConditionPresetNameDialog extends Mixins(ModelEditableMixin, DialogMixin) {
  data(): any {
    return {
      isAdd: false,
      presetName: "",
      isEditDefault: false,
      defaultSort: false,
      result: false,
    };
  }
  isAdd: boolean;
  presetName: string;
  isEditDefault: boolean;
  defaultSort: boolean;
  result: boolean;

  get title(): string {
    return this.isAdd
      ? "プリセット追加"
      : "プリセット設定";
  }

  get disabledSave(): boolean {
    return this.presetName === "";
  }

  async show(param: IListMultiSortConditionPresetNameDialogParameter): Promise<IListMultiSortConditionPresetNameDialogResult> {
    await this.showModal(async () => {
      this.isAdd = param.isAdd;
      this.presetName = param.presetName;
      this.isEditDefault = param.isEditDefault;
      this.defaultSort = false;
      this.result = false;
      await this.waitHidden(); 
    });
    return {
      result: this.result,
      presetName: this.presetName,
      defaultSort: this.defaultSort,
    };
  }

  save() {
    this.result = true;
    this.isVisible = false;
  }

  cancel() {
    this.isVisible = false;
  }
}
